import type { AlertValues } from "@nabla/api";
import { alertCopy as t } from "./alert-copy.ts";

type Said = AlertValues<"drive-sem-acesso">;
const refusal = ({ motivo }: Said) => (motivo === "conta-recusada" ? "credencial-recusada" : motivo);

export const alerts = {
  "drive-sem-acesso": {
    says: (v: Said) => t.semAcesso[refusal(v)](v.credencial),
    next: (v: Said) => t.proximo[v.motivo],
  },
};
